/* global window */

/**
 * Utilidades para convertir entre unidades (ej. 6.40) y centavos (640),
 * tal como Shopify espera en los parámetros de filtros de precio.
 *
 * - En el navegador: expone `window.PriceRangeUtils`
 * - En Node (tests): exporta vía `module.exports`
 */

function clampNumber(n) {
  const x = Number(n);
  return Number.isFinite(x) ? x : 0;
}

function toCents(amount) {
  // Evita errores de coma flotante: 6.4 * 100 => 640, 0.07 * 100 => 7
  return Math.round(clampNumber(amount) * 100);
}

function fromCents(cents) {
  return clampNumber(cents) / 100;
}

const api = { toCents, fromCents };

if (typeof window !== 'undefined') {
  window.PriceRangeUtils = api;
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = api;
}

